import React, { Component } from "react";
import styled from "styled-components";
import { observer, inject } from "mobx-react";
import { computed } from "mobx";
import { NavLink } from "react-router-dom";
import { DatabaseIcon, UserCircleIcon } from "@heroicons/react/outline";

import { IconDashboard } from "./Icons";

import { useLocation } from "react-router-dom";
import Body from "./Components/Body";
import { withRouter } from "react-router-dom";

function HeaderExpand(props) {
  const location = useLocation();
  return (
    <SuperHeader active={location.pathname === "/" ? true : false}>
      {props.children}
    </SuperHeader>
  );
}

@inject("store")
@observer
class SidebarCompontent extends Component {
  constructor(props) {
    super(props);
    if (this.props.location.pathname === "/signup") {
      this.props.history.push("/");
    }
    if (this.props.location.pathname === "/login") {
      this.props.history.push("/");
    }
  }
  componentDidMount() {
    document.addEventListener("keydown", this.shortcutHandler);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.shortcutHandler);
  }
  shortcutHandler = (e) => {
    if (e.keyCode === 75 && e.ctrlKey) {
      e.preventDefault();
      // select all text in input with id q
      document.getElementById("q").focus();
      document.getElementById("q").select();
    }
  };

  onKeyUp = (e) => {
    if (this.props.location.pathname !== "/search") {
      this.props.history.push("/search");
    }
    if (e.keyCode === 8) {
      if (this.props.store.toolsKeyword === "") {
        this.props.history.push("/");
      }
    }
  };

  @computed get fromColor() {
    if (this.props.store.profile.credits <= 0) {
      return "insufficient-credits text-white";
    }
    if (this.props.store.profile.status === "trialing") {
      return "";
    }
    if (this.props.store.profile.status === "active") {
      return "";
    }
    if (this.props.store.profile.status === "incomplete") {
      return "";
    }
    return "bg-navix-lavender text-navix-ivory";
  }

  render() {
    return (
      <>
        <Textarea
          readOnly
          name="copy-textarea"
          id="copy-textarea"
          value={this.props.store.copyToClipboardText}
        />
        <HeaderExpand>
          <Body className="px-4 py-4 md:px-28 md:py-8 lg:py-12 flex items-center flex-1">
            <div className="mr-4 ">
              <NavLink to="/">
                <Logo />
              </NavLink>
            </div>
            <div>
              {/* <div className="text-4xl relative font-medium text-transparent bg-clip-text bg-gradient-to-r from-red-700 to-red-600 inline-block">Navix<span className="font-normal "> AI Hub</span>  */}
              <div className="text-4xl relative font-medium text-transparent bg-clip-text text-navix-golden inline-block pl-20 md:pl-0">
                MedcodeAI
                <span className="font-normal ">
                  {" "}
                  - Tools for Medical Coding Professionals
                </span>
                <div className="absolute top-0 ml-3 left-full bg-gradient-to-br from-gray-500 to-gray-500 text-white text-sm px-2 py-0.5 rounded-md font-normal hidden md:flex">
                  beta
                </div>
              </div>
              <div className="hidden md:block text-xl text-transparent bg-clip-text bg-gradient-to-r from-gray-100 to-gray-200 inline-block">
                Select a tool from our Library
              </div>
              <div className="flex">
                <div
                  className={`items-center flex inline-flex ${
                    this.props.store.profile.credits
                      ? " bg-gray-100 text-gray-500"
                      : " bg-red-100 text-red-500"
                  } text-sm rounded-md px-3 py-1 font-medium my-2 mr-2 ml-20 md:ml-0`}
                >
                  <DatabaseIcon className="w-4 h-4 mr-2" />
                  {Math.max(this.props.store.profile.credits, 0)}&nbsp;
                  <span className="hidden lg:block">credits remain</span>
                </div>
              </div>
            </div>
          </Body>
        </HeaderExpand>
        <div className="border-b border-gray-300 bg-gradient shadow-sm ">
          <div className="container flex mx-auto px-4 md:px-28 flex select-none">
            <NavLink
              to="/"
              exact
              tabIndex={-1}
              onClick={() => (this.props.store.toolsKeyword = "")}
              activeClassName="bg-navix-turquoise hover:bg-navix-lavender text-gray-800 transition"
              className="text-lg flex py-3 px-6 lg:py-4 lg:px-8 cursor-pointer hover:bg-navix-lavender rounded-t-md font-medium transition items-center"
            >
              <IconDashboard className="w-7 h-7 lg:mr-4 transition" />
              <div className="hidden lg:block">Tools</div>
            </NavLink>

            <div className="relative text-navix-ivory focus-within:text-green-500 flex flex-1 ">
              <label
                htmlFor="q"
                className="absolute inset-y-0 left-0 top-0 bottom-0 hidden md:flex items-center lg:pl-2 "
              >
                <div
                  type="submit"
                  className="p-2 focus:outline-none focus:shadow-outline "
                >
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    className="w-6 h-6 transition"
                  >
                    <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                </div>
              </label>
              <Input
                type="search"
                tabIndex={-1}
                id="q"
                name="q"
                className="py-4 pl-4 md:pl-14 text-xl focus:outline-none focus:bg-white focus:text-gray-900 transition flex flex-1 w-full"
                placeholder="Search...  [Shortcut: Ctrl + K]"
                autoComplete="off"
                value={this.props.store.toolsKeyword}
                onChange={this.props.store.onChangeToolsKeyword}
                onKeyUp={this.onKeyUp}
              />
            </div>
            <NavLink
              to="/my-profile"
              exact
              tabIndex="-1"
              activeClassName="bg-navix-lavender hover:bg-navix-golden text-green-800 transition"
              className={`text-lg flex py-3 px-6 xl:py-4 xl:px-8 cursor-pointer ${this.fromColor} hover:bg-navix-golden rounded-t-md font-medium transition items-center`}
            >
              <UserCircleIcon className="w-7 h-7 lg:mr-4 transition" />
              <div className="hidden lg:block"> My Profile</div>
            </NavLink>
          </div>
        </div>
        {this.props.children}
      </>
    );
  }
}

// const Logo = () => (
// 	<svg
// 	xmlns="http://www.w3.org/2000/svg"
// 	fill="none"
// 	className="w-20 h-20"
// 	viewBox="0 0 1512 1532"
//   >
// 	<path
// 	  fill="#000"
// 	  d="M1412.22 627.024a381.628 381.628 0 0017.47-160.247 381.625 381.625 0 00-50.27-153.158 385.877 385.877 0 00-177.63-160.359 385.89 385.89 0 00-238.016-24.803A381.525 381.525 0 00833.74 33.209 381.565 381.565 0 00675.978.154a385.936 385.936 0 00-368.15 267.204A381.68 381.68 0 0052.672 452.459 385.97 385.97 0 002.636 686.458a385.954 385.954 0 0097.504 218.517 381.566 381.566 0 0032.793 313.405 385.943 385.943 0 00415.649 185.16 381.574 381.574 0 00287.797 128.31 385.89 385.89 0 00227.731-73.63 385.855 385.855 0 00140.54-193.73 381.572 381.572 0 00147.58-64.98c44-31.92 80.68-72.88 107.58-120.12a386.032 386.032 0 0049.92-233.94 385.967 385.967 0 00-97.51-218.426zM836.501 1431.71a286.188 286.188 0 01-183.744-66.43c2.325-1.26 6.403-3.5 9.061-5.13l304.978-176.16a49.595 49.595 0 0025.062-43.39V710.636l128.912 74.434c.67.337 1.25.834 1.69 1.451.44.616.72 1.333.81 2.079v356.07a287.37 287.37 0 01-84.08 202.77 287.387 287.387 0 01-202.689 84.27zm-616.724-263.39a286.085 286.085 0 01-34.242-192.354c2.264 1.36 6.22 3.776 9.059 5.407l304.977 176.157a49.582 49.582 0 0025.051 6.79c8.8 0 17.447-2.34 25.048-6.79l372.346-214.989v148.869c.042.76-.103 1.52-.425 2.21a4.548 4.548 0 01-1.417 1.74l-308.302 178.01a287.314 287.314 0 01-217.77 28.55 287.33 287.33 0 01-174.325-133.6zm-80.231-665.797a285.999 285.999 0 01149.41-125.856c0 2.627-.151 7.279-.151 10.507v352.327a49.55 49.55 0 0025.033 43.363l372.345 214.967-128.904 74.429c-.636.42-1.368.67-2.126.74a4.702 4.702 0 01-2.225-.34l-308.33-178.161a287.348 287.348 0 01-105.052-391.976zm1059.094 246.46L826.292 533.988l128.909-74.402a4.596 4.596 0 014.346-.391l308.333 178.004a287.1 287.1 0 01142.45 273.103 287.09 287.09 0 01-57.78 149.628 287.044 287.044 0 01-129.03 95.28V792.345a49.468 49.468 0 00-6.57-25.051 49.515 49.515 0 00-18.31-18.311zm128.3-193.103c-2.26-1.39-6.22-3.775-9.05-5.403L1012.9 374.312a49.683 49.683 0 00-50.09 0L590.463 589.31V440.443a4.613 4.613 0 011.842-3.955l308.302-177.857a287.08 287.08 0 01155.713-38.117 287.052 287.052 0 01151.87 51.322 287.09 287.09 0 01100.67 124.758 286.994 286.994 0 0118.08 159.286zM520.38 821.214l-128.939-74.433a4.572 4.572 0 01-2.505-3.535V387.174a287.084 287.084 0 0144.883-153.942 287.095 287.095 0 01120.453-105.853 287.069 287.069 0 01305.419 39.366c-2.324 1.268-6.372 3.503-9.06 5.134L545.653 348.042a49.548 49.548 0 00-25.063 43.36l-.21 429.812zm70.022-150.98l165.838-95.782 165.834 95.72v191.502L756.24 957.398l-165.838-95.724v-191.44z"
// 	></path>
//   </svg>

// )

const Logo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 269.6 69.7"
    style={{
      enableBackground: "new 0 0 269.6 69.7",
    }}
    xmlSpace="preserve"
    // {...props}
  >
    <path
      d="m43.3 63.8-.3 1.6h-.6l1.2-5.4h.7l1.2 5.4h-.6l-.4-1.6h-1.2zm1.2-.5-.3-1.4c-.1-.4-.2-.8-.2-1.2-.1.4-.1.9-.2 1.2l-.3 1.4h1zm5 1.4c.2.1.5.2.8.2.6 0 .9-.4.9-.9s-.3-.8-.7-1.1c-.4-.3-1-.8-1-1.5 0-.8.6-1.4 1.4-1.4.3 0 .6.1.8.2l-.1.5c-.1-.1-.4-.2-.6-.2-.5 0-.8.4-.8.8 0 .5.3.7.8 1.1.6.5.9 1 .9 1.6 0 .9-.7 1.5-1.5 1.5-.4 0-.8-.1-.9-.2v-.6zm4.7-1.2c0 1.2.5 1.4.9 1.4.3 0 .5-.1.6-.1l.1.4c-.2.1-.5.2-.9.2-.9 0-1.4-.8-1.4-1.9 0-1.3.5-2 1.3-2s1.1.8 1.1 1.7v.3h-1.7zm1.2-.4c0-.8-.3-1.1-.6-1.1-.4 0-.6.6-.6 1.1h1.2zm3.9 2.3V65c-.2.3-.4.5-.8.5-.5 0-.9-.4-.9-1.1 0-1 .8-1.4 1.7-1.4v-.1c0-.5-.1-.9-.6-.9-.2 0-.5.1-.6.2l-.1-.4c.2-.1.5-.3.9-.3.8 0 1.1.5 1.1 1.4v2.6h-.7zm0-2c-.3 0-1.1.1-1.1.9 0 .5.3.7.5.7.3 0 .5-.2.6-.6v-1zm2.6-.8v-1h.5v.5c.2-.3.5-.5.9-.5s.7.2.8.6c.1-.2.2-.3.4-.4.2-.1.3-.1.5-.1.5 0 .9.4.9 1.4v2.6h-.6V63c0-.5-.1-1-.5-1-.3 0-.5.2-.6.6v2.8h-.6v-2.5c0-.4-.1-.9-.5-.9-.3 0-.5.2-.6.6v2.8h-.6v-2.8zm6.1-2.7h.6v5.5H68v-5.5zm3.2 3.6c0 1.2.5 1.4.9 1.4.3 0 .5-.1.6-.1l.1.4c-.2.1-.5.2-.9.2-.9 0-1.4-.8-1.4-1.9 0-1.3.5-2 1.3-2s1.1.8 1.1 1.7v.3h-1.7zm1.2-.4c0-.8-.3-1.1-.6-1.1-.4 0-.6.6-.6 1.1h1.2zm2.4 1.7c.1.1.4.2.6.2.3 0 .6-.2.6-.6 0-.3-.1-.5-.5-.8-.5-.3-.8-.7-.8-1.1 0-.6.5-1.1 1.1-1.1.3 0 .5.1.7.2l-.2.5c-.1 0-.3-.1-.5-.1-.3 0-.5.2-.5.5s.1.4.5.7c.4.3.8.6.8 1.2 0 .8-.5 1.1-1.2 1.1-.3 0-.6-.1-.8-.2l.2-.5zm3.5 0c.1.1.4.2.6.2.3 0 .6-.2.6-.6 0-.3-.1-.5-.5-.8-.5-.3-.8-.7-.8-1.1 0-.6.5-1.1 1.1-1.1.3 0 .5.1.7.2l-.2.5c-.1-.1-.3-.2-.5-.2-.3 0-.5.2-.5.5s.1.4.5.7c.4.3.8.6.8 1.2 0 .8-.5 1.1-1.2 1.1-.3 0-.6-.1-.8-.2l.2-.4zm6.6-1-.4 1.6H84l1.2-5.4h.7l1.2 5.4h-.6l-.4-1.6h-1.2zm1.2-.5-.3-1.4c-.1-.4-.2-.8-.2-1.2-.1.4-.1.9-.2 1.2l-.4 1.4h1.1zm2.8-.5v-1.2h.5v.5c.2-.4.5-.6.8-.6.7 0 1.1.7 1.1 2 0 1.4-.6 2-1.2 2-.4 0-.6-.2-.7-.4V67h-.6v-4.2zm.6 1.2v.3c.1.6.4.6.6.6.5 0 .7-.7.7-1.5s-.2-1.5-.7-1.5c-.3 0-.5.3-.6.7V64zm3.8-1.2v-1.2h.5v.5c.2-.4.5-.6.8-.6.7 0 1.1.7 1.1 2 0 1.4-.6 2-1.2 2-.4 0-.6-.2-.7-.4V67h-.6v-4.2zm.6 1.2v.3c.1.6.4.6.6.6.5 0 .7-.7.7-1.5s-.2-1.5-.7-1.5c-.3 0-.5.3-.6.7V64zm3.8-1.4v-1h.5v.6c.1-.4.5-.7.8-.7h.1v.6H99c-.4 0-.7.4-.7.8v2.5h-.6v-2.8zm5.6.9c0 1.5-.7 2-1.3 2-.7 0-1.3-.6-1.3-2s.6-2 1.3-2c.7 0 1.3.6 1.3 2zm-2 0c0 .6.1 1.5.7 1.5.5 0 .6-.9.6-1.5s-.1-1.5-.7-1.5c-.5 0-.6.9-.6 1.5zm5.4 1.9V65c-.2.3-.4.5-.8.5-.5 0-.9-.4-.9-1.1 0-1 .8-1.4 1.7-1.4v-.1c0-.5-.1-.9-.6-.9-.2 0-.5.1-.6.2l-.1-.4c.2-.1.5-.3.9-.3.8 0 1.1.5 1.1 1.4v2.6h-.7zm-.1-2c-.3 0-1.1.1-1.1.9 0 .5.3.7.5.7.3 0 .5-.2.6-.6v-1zm4.6 1.9c-.1.1-.4.1-.6.1-.8 0-1.4-.7-1.4-2 0-1.1.6-2 1.5-2 .2 0 .4.1.5.1l-.1.5c-.1 0-.2-.1-.4-.1-.6 0-.9.7-.9 1.5 0 .9.3 1.4.9 1.4.2 0 .3 0 .4-.1l.1.6zm1.7-5.4h.6V62c.1-.1.2-.3.3-.3.1-.1.3-.1.5-.1.5 0 .9.4.9 1.4v2.6h-.6v-2.5c0-.5-.1-.9-.5-.9-.3 0-.5.2-.6.6v2.8h-.6v-5.7zm7.5.6v1h.7v.5h-.7v2.3c0 .5.2.6.4.6h.2v.5c-.1 0-.3.1-.5.1s-.5-.1-.6-.2c-.2-.2-.2-.4-.2-1V62h-.5v-.5h.5v-.9l.7-.1zm4.9 3c0 1.5-.7 2-1.3 2-.7 0-1.3-.6-1.3-2s.6-2 1.3-2c.7 0 1.3.6 1.3 2zm-2 0c0 .6.1 1.5.7 1.5.5 0 .6-.9.6-1.5s-.1-1.5-.7-1.5c-.5 0-.6.9-.6 1.5zm6.2-3.4c.3-.1.6-.1.9-.1.5 0 .9.1 1.2.4.2.2.4.5.4.9 0 .5-.3 1-.8 1.2.6.2 1 .7 1 1.4 0 .4-.1.8-.4 1.1-.3.3-.8.5-1.4.5-.4 0-.6 0-.8-.1v-5.3zm.6 2.2h.3c.5 0 .9-.4.9-1 0-.5-.2-.9-.9-.9h-.3v1.9zm0 2.6h.3c.6 0 1.1-.4 1.1-1.1 0-.7-.5-1.1-1.1-1.1h-.3v2.2zm4.4-1.4c0 1.2.5 1.4.9 1.4.3 0 .5-.1.6-.1l.1.4c-.2.1-.5.2-.9.2-.9 0-1.4-.8-1.4-1.9 0-1.3.5-2 1.3-2s1.1.8 1.1 1.7v.3h-1.7zm1.2-.4c0-.8-.3-1.1-.6-1.1-.4 0-.6.6-.6 1.1h1.2zm2.4-3.2h.6V62c.1-.1.2-.3.3-.3.1-.1.3-.1.5-.1.5 0 .9.4.9 1.4v2.6h-.6v-2.5c0-.5-.1-.9-.5-.9-.3 0-.5.2-.6.6v2.8h-.6v-5.7zm6 5.5V65c-.2.3-.4.5-.8.5-.5 0-.9-.4-.9-1.1 0-1 .8-1.4 1.7-1.4v-.1c0-.5-.1-.9-.6-.9-.2 0-.5.1-.6.2l-.1-.4c.2-.1.5-.3.9-.3.8 0 1.1.5 1.1 1.4v2.6h-.7zm-.1-2c-.3 0-1.1.1-1.1.9 0 .5.3.7.5.7.3 0 .5-.2.6-.6v-1zm2.9-1.8.5 2.2c.1.3.1.6.2.9 0-.3.1-.6.2-.9l.5-2.2h.6l-1 3.9h-.5l-1-3.9h.5zm4.4-1c0 .2-.1.4-.4.4-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.1.4.4zm-.7 4.8v-3.9h.6v3.9h-.6zm5-1.9c0 1.5-.7 2-1.3 2-.7 0-1.3-.6-1.3-2s.6-2 1.3-2c.8 0 1.3.6 1.3 2zm-1.9 0c0 .6.1 1.5.7 1.5.5 0 .6-.9.6-1.5s-.1-1.5-.7-1.5c-.5 0-.6.9-.6 1.5zm3.8-.9v-1h.5v.6c.1-.4.5-.7.8-.7h.1v.6h-.1c-.4 0-.7.4-.7.8v2.5h-.6v-2.8zm4.8 2.8V65c-.2.3-.4.5-.8.5-.5 0-.9-.4-.9-1.1 0-1 .8-1.4 1.7-1.4v-.1c0-.5-.1-.9-.6-.9-.2 0-.5.1-.6.2l-.1-.4c.2-.1.5-.3.9-.3.8 0 1.1.5 1.1 1.4v2.6h-.7zm-.1-2c-.3 0-1.1.1-1.1.9 0 .5.3.7.5.7.3 0 .5-.2.6-.6v-1zm2.7-3.5h.6v5.5h-.6v-5.5zm5.6.1v2.3h1.5V60h.6v5.4h-.6v-2.5h-1.5v2.5h-.6V60h.6zm4.7 3.5c0 1.2.5 1.4.9 1.4.3 0 .5-.1.6-.1l.1.4c-.2.1-.5.2-.9.2-.9 0-1.4-.8-1.4-1.9 0-1.3.5-2 1.3-2s1.1.8 1.1 1.7v.3h-1.7zm1.3-.4c0-.8-.3-1.1-.6-1.1-.4 0-.6.6-.6 1.1h1.2zm3.9 2.3V65c-.2.3-.4.5-.8.5-.5 0-.9-.4-.9-1.1 0-1 .8-1.4 1.7-1.4v-.1c0-.5-.1-.9-.6-.9-.2 0-.5.1-.6.2l-.1-.4c.2-.1.5-.3.9-.3.8 0 1.1.5 1.1 1.4v2.6h-.7zm-.1-2c-.3 0-1.1.1-1.1.9 0 .5.3.7.5.7.3 0 .5-.2.6-.6v-1zm2.6-3.5h.6v5.5h-.6v-5.5zm3.5.6v1h.7v.5h-.7v2.3c0 .5.2.6.4.6h.2v.5c-.1 0-.3.1-.5.1s-.5-.1-.6-.2c-.2-.2-.2-.4-.2-1V62h-.5v-.5h.5v-.9l.7-.1zm2.5-.6h.6V62c.1-.1.2-.3.3-.3.1-.1.3-.1.5-.1.5 0 .9.4.9 1.4v2.6h-.6v-2.5c0-.5-.1-.9-.5-.9-.3 0-.5.2-.6.6v2.8h-.6v-5.7zm6.7 4.8c.2.1.5.2.8.2.6 0 .9-.4.9-.9s-.3-.8-.7-1.1c-.4-.3-1-.8-1-1.5 0-.8.6-1.4 1.4-1.4.3 0 .6.1.8.2l-.1.5c-.1-.1-.4-.2-.6-.2-.5 0-.8.4-.8.8 0 .5.3.7.8 1.1.6.5.9 1 .9 1.6 0 .9-.7 1.5-1.5 1.5-.4 0-.8-.1-.9-.2v-.6zm6.6-1.2c0 1.5-.7 2-1.3 2-.7 0-1.3-.6-1.3-2s.6-2 1.3-2c.7 0 1.3.6 1.3 2zm-1.9 0c0 .6.1 1.5.7 1.5.5 0 .6-.9.6-1.5s-.1-1.5-.7-1.5c-.5 0-.6.9-.6 1.5zm3.9 1.9V62h-.5v-.5h.5v-.2c0-.4.1-.8.3-1.2.2-.3.5-.3.8-.3.2 0 .4 0 .5.1l-.1.5c-.1 0-.2-.1-.3-.1-.4 0-.5.5-.5 1v.2h.7v.5h-.7v3.4h-.7zm3.9-4.9v1h.7v.5h-.7v2.3c0 .5.2.6.4.6h.2v.5c-.1 0-.3.1-.5.1s-.5-.1-.6-.2c-.2-.2-.2-.4-.2-1V62h-.4v-.5h.5v-.9l.6-.1zm3 1.1.4 1.9c.1.4.2.8.2 1.2.1-.4.2-.8.2-1.2l.4-1.9h.5l.4 1.9c.1.4.2.8.3 1.3 0-.4.1-.8.2-1.3l.4-1.9h.6l-1 3.9h-.5l-.4-1.9c-.1-.4-.2-.7-.2-1.2-.1.5-.1.8-.2 1.2l-.5 1.9h-.5l-.9-3.9h.6zm7 3.8V65c-.2.3-.4.5-.8.5-.5 0-.9-.4-.9-1.1 0-1 .8-1.4 1.7-1.4v-.1c0-.5-.1-.9-.6-.9-.2 0-.5.1-.6.2l-.1-.4c.2-.1.5-.3.9-.3.8 0 1.1.5 1.1 1.4v2.6h-.7zm-.1-2c-.3 0-1.1.1-1.1.9 0 .5.3.7.5.7.3 0 .5-.2.6-.6v-1zm2.6-.8v-1h.5v.6c.1-.4.5-.7.8-.7h.1v.6h-.1c-.4 0-.7.4-.7.8v2.5h-.6v-2.8zm3.6.9c0 1.2.5 1.4.9 1.4.3 0 .5-.1.6-.1l.1.4c-.2.1-.5.2-.9.2-.9 0-1.4-.8-1.4-1.9 0-1.3.5-2 1.3-2s1.1.8 1.1 1.7v.3h-1.7zm1.2-.4c0-.8-.3-1.1-.6-1.1-.4 0-.6.6-.6 1.1h1.2z"
      style={{
        fill: "#c2986c",
      }}
    />
    <defs>
      <path
        id="a"
        d="M118.1 39 98.5 2.3h-5.4l22 42.4h2.7l21.6-42.4h-2.6L118.1 39zm29.2 5.7h4.6V2.3h-4.6v42.4zM44 38.1 6.9 2.3H2.6v42.4h2.1V6.4l39.1 38.3h2.4V2.3H44v35.8zM76.7 2.3 60.9 28.9l-9.4 15.8h2.4l8.5-14h28.4l8.7 14h5.1L78.9 2.3h-2.2zM63.4 28.9 76.3 7.7l13.3 21.2H63.4zM203.8 2.3h-2.7l-17.3 18.8L167 2.3h-5.6l19.8 21.8-18.9 20.6h2.6l17.6-19.2 17.4 19.2h5.2l-19.9-22.1 18.6-20.3zm62.1 17v4.4H263v-4.4h-1.2v10.3h1.2v-4.8h2.9v4.8h1.2V19.3h-1.2zm-22 0h-1.2v10.3h4.1v-1h-2.9v-9.3zm7.3 1h1.9v9.2h1.2v-9.2h1.9v-1.1h-4.9v1.1zm-28.5 4.4h2.6v-1h-2.6v-3.4h2.7v-1h-3.9v10.3h4.1v-1h-2.9v-3.9zm10.7-5.4L231 29.6h1.1l.7-3.1h2.3l.7 3.1h1.2l-2.3-10.3h-1.3zm-.3 6.3.5-2.6c.1-.7.3-1.6.4-2.4h.1c.1.8.3 1.6.4 2.3l.5 2.6h-1.9zm-19-1.9h-2.9v-4.4H210v10.3h1.2v-4.8h2.9v4.8h1.2V19.3h-1.2v4.4z"
      />
    </defs>
    <clipPath id="b">
      <use
        xlinkHref="#a"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b8a180",
      }}
      d="M210.1 19.3h-.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b8a280",
      }}
      d="m211.4 19.3-1.4 1.3v-1.3h.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b7a280",
      }}
      d="m212.7 19.3-2.7 2.6v-1.3l1.4-1.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b6a381",
      }}
      d="m214 19.3-4 3.9v-1.3l2.7-2.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b7a382",
      }}
      d="m215.2 19.3-5.2 5.2v-1.3l4-3.9h1.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b6a483",
      }}
      d="m215.2 20.6-5.2 5.2v-1.3l5.2-5.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b5a484",
      }}
      d="m215.2 21.9-5.2 5.2v-1.3l5.2-5.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b4a485",
      }}
      d="m215.2 23.2-5.2 5.2v-1.3l5.2-5.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b5a586",
      }}
      d="m215.2 24.5-5.1 5.1h-.1v-1.2l5.2-5.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b4a586",
      }}
      d="m215.2 25.8-3.8 3.8h-1.3l5.1-5.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b3a587",
      }}
      d="m215.2 27.1-2.5 2.5h-1.3l3.8-3.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2a688",
      }}
      d="m215.2 28.3-1.2 1.3h-1.3l2.5-2.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b3a689",
      }}
      d="m214 29.6 1.2-1.3v1.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#afa98f",
      }}
      d="m233.3 20.6-.2.3v-.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#afa990",
      }}
      d="m234.6 20.6-1.5 1.6v-1.3l.2-.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#aea991",
      }}
      d="m235 21.5-1.9 1.9v-1.2l1.5-1.6h.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ada992",
      }}
      d="m235 22.8-1.9 1.9v-1.3l1.9-1.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#adaa93",
      }}
      d="m235 24.1-1.4 1.5h-.5v-.9l1.9-1.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#acaa94",
      }}
      d="m235 25.4-.1.2h-1.3l1.4-1.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#abab95",
      }}
      d="m234.9 25.6.1-.2v.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b0a88d",
      }}
      d="m232.1 19.3-1 1v-1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#afa88e",
      }}
      d="m233.4 19.3-2.3 2.3v-1.3l1-1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#afa98f",
      }}
      d="m234.6 19.3-3.5 3.5v-1.2l2.3-2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#afa990",
      }}
      d="m235.9 19.3-4.8 4.8v-1.3l3.5-3.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#aea991",
      }}
      d="m237 19.5-5.9 5.9v-1.3l4.8-4.8h1.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ada992",
      }}
      d="m237 20.8-5.9 5.9v-1.3l5.9-5.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#adaa93",
      }}
      d="m237 22.1-5.9 5.9v-1.3l5.9-5.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#acaa94",
      }}
      d="m237 23.4-5.9 5.9V28l5.9-5.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#abab95",
      }}
      d="m237 24.7-4.9 4.9h-1v-.3l5.9-5.9zm0 1.3-3.6 3.6h-1.3l4.9-4.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#abac97",
      }}
      d="m237 27.3-2.3 2.3h-1.3L237 26z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#aaac97",
      }}
      d="m237 28.5-1 1.1h-1.3l2.3-2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a9ac98",
      }}
      d="m236 29.6 1-1.1v1.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b4a586",
      }}
      d="m221.7 19.3-.2.2v-.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b3a587",
      }}
      d="m223 19.3-1.5 1.5v-1.3l.2-.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2a688",
      }}
      d="m224.3 19.3-2.8 2.8v-1.3l1.5-1.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b3a689",
      }}
      d="m225.6 19.3-4.1 4v-1.2l2.8-2.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2a68a",
      }}
      d="m225.6 20.5-4.1 4.1v-1.3l4.1-4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b1a68b",
      }}
      d="m225.6 21.8-4.1 4.1v-1.3l4.1-4.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2a78c",
      }}
      d="m225.6 23.1-4.1 4.1v-1.3l4.1-4.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b1a88d",
      }}
      d="m225.6 24.4-4.1 4.1v-1.3l4.1-4.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b0a88d",
      }}
      d="m225.6 25.7-3.8 3.9h-.3v-1.1l4.1-4.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#afa88e",
      }}
      d="m225.6 27-2.5 2.6h-1.3l3.8-3.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#afa98f",
      }}
      d="m225.6 28.3-1.2 1.3h-1.3l2.5-2.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#afa990",
      }}
      d="m224.4 29.6 1.2-1.3v1.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a8ad9b",
      }}
      d="m251.5 19.3-.3.3v-.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a7ae9c",
      }}
      d="m252.8 19.3-1.6 1.5v-1.2l.3-.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a6af9e",
      }}
      d="m254.1 19.3-2.9 2.8v-1.3l1.6-1.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a6af9f",
      }}
      d="m255.3 19.3-4.1 4.1v-1.3l2.9-2.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a5af9f",
      }}
      d="m256.1 19.8-4.9 4.9v-1.3l4.1-4.1h.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a4afa0",
      }}
      d="m256.1 21.1-4.9 4.9v-1.3l4.9-4.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a4b0a2",
      }}
      d="m256.1 22.4-4.9 4.9V26l4.9-4.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a4b1a3",
      }}
      d="m256.1 23.7-4.9 4.9v-1.3l4.9-4.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a3b0a3",
      }}
      d="m256.1 25-4.6 4.6h-.3v-1l4.9-4.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a3b2a5",
      }}
      d="m256.1 26.3-3.3 3.3h-1.3l4.6-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a3b2a6",
      }}
      d="m256.1 27.5-2 2.1h-1.3l3.3-3.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a2b2a6",
      }}
      d="m256.1 28.8-.7.8h-1.3l2-2.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a1b2a7",
      }}
      d="m255.4 29.6.7-.8v.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#abab95",
      }}
      d="m243.7 19.3-.9.9v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#abac97",
      }}
      d="m245 19.3-2.2 2.2v-1.3l.9-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#aaac97",
      }}
      d="m246.3 19.3-3.5 3.5v-1.3l2.2-2.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a9ac98",
      }}
      d="M246.8 19.3v.8l-4 4v-1.3l3.5-3.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a9ad99",
      }}
      d="m246.8 21.4-4 4v-1.3l4-4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a9ad9a",
      }}
      d="m246.8 22.6-4 4.1v-1.3l4-4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a8ad9b",
      }}
      d="m246.8 23.9-4 4.1v-1.3l4-4.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a7ae9c",
      }}
      d="m246.8 25.2-4 4.1V28l4-4.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a6af9e",
      }}
      d="m246.8 26.5-3 3.1h-1v-.3l4-4.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a6af9f",
      }}
      d="m246.8 27.8-1.8 1.8h-1.2l3-3.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a5af9f",
      }}
      d="m246.8 29.1-.5.5H245l1.8-1.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a4afa0",
      }}
      d="m246.3 29.6.5-.5v.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a3b2a5",
      }}
      d="m263.1 19.3-1.3 1.3v-1.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a3b2a6",
      }}
      d="m264.4 19.3-2.6 2.6v-1.3l1.3-1.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a2b2a6",
      }}
      d="m265.7 19.3-3.9 3.9v-1.3l2.6-2.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a1b2a7",
      }}
      d="m267 19.3-5.2 5.2v-1.3l3.9-3.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a1b3a9",
      }}
      d="m267 20.5-5.2 5.3v-1.3l5.2-5.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a1b4aa",
      }}
      d="m267 21.8-5.2 5.3v-1.3l5.2-5.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a0b4aa",
      }}
      d="m267 23.1-5.2 5.2v-1.2l5.2-5.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9fb4ab",
      }}
      d="m267 24.4-5.1 5.2h-.1v-1.3l5.2-5.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9eb5ad",
      }}
      d="m267 25.7-3.8 3.9h-1.3l5.1-5.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9eb5ae",
      }}
      d="m267 27-2.5 2.6h-1.3l3.8-3.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9db6af",
      }}
      d="m267 28.3-1.3 1.3h-1.2L267 27z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9cb6b0",
      }}
      d="M267 29.6h-1.3l1.3-1.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9cb6b0",
      }}
      d="M267 29.6h-5.2V19.3h5.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ac856c",
      }}
      d="m161.9 2.3-.5.5v-.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ad866c",
      }}
      d="m162.7 2.3-1.3 1.3v-.8l.5-.5zm.8 0-2.1 2.1v-.8l1.3-1.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ae876c",
      }}
      d="m164.3 2.3-2.9 3v-.9l2.1-2.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ae876c",
      }}
      d="m165.2 2.3-3.8 3.8v-.8l2.9-3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#af886c",
      }}
      d="m166 2.3-4.6 4.6v-.8l3.8-3.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b0886c",
      }}
      d="m166.8 2.3-5.4 5.4v-.8l4.6-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b0886c",
      }}
      d="m167.6 2.3-6.2 6.2v-.8l5.4-5.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b1896c",
      }}
      d="m168.4 2.3-7 7.1v-.9l6.2-6.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2896c",
      }}
      d="m169.3 2.3-7.9 7.9v-.8l7-7.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b28b6c",
      }}
      d="m170.1 2.3-8.7 8.7v-.8l7.9-7.9zm.8 0-9.5 9.5V11l8.7-8.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b38b6c",
      }}
      d="m171.7 2.3-10.3 10.3v-.8l9.5-9.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b48c6c",
      }}
      d="m172.5 2.3-11.1 11.2v-.9l10.3-10.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b58c6d",
      }}
      d="m173.4 2.3-12 12v-.8l11.1-11.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b58c6c",
      }}
      d="m174.2 2.3-12.8 12.8v-.8l12-12z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b58d6c",
      }}
      d="m175 2.3-13.6 13.6v-.8l12.8-12.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b68d6c",
      }}
      d="m175.8 2.3-14.4 14.4v-.8L175 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b68e6c",
      }}
      d="m176.6 2.3-15.2 15.3v-.9l14.4-14.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b78e6c",
      }}
      d="m177.5 2.3-16.1 16.1v-.8l15.2-15.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b78f6c",
      }}
      d="m178.3 2.3-16.9 16.9v-.8l16.1-16.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b8906c",
      }}
      d="M179.1 2.3 161.4 20v-.8l16.9-16.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b9906c",
      }}
      d="m179.9 2.3-18.5 18.6V20l17.7-17.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b9916c",
      }}
      d="m180.8 2.3-19.4 19.4v-.8l18.5-18.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ba916c",
      }}
      d="m181.6 2.3-20.2 20.2v-.8l19.4-19.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ba916d",
      }}
      d="m182.4 2.3-21 21v-.8l20.2-20.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bb926c",
      }}
      d="m183.2 2.3-21.8 21.8v-.8l21-21zm.8 0L161.4 25v-.9l21.8-21.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bc936d",
      }}
      d="m184.9 2.3-23.5 23.5V25L184 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bd936c",
      }}
      d="m185.7 2.3-24.3 24.3v-.8l23.5-23.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be946c",
      }}
      d="m186.5 2.3-25.1 25.1v-.8l24.3-24.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be956c",
      }}
      d="m187.3 2.3-25.9 25.9v-.8l25.1-25.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bd956c",
      }}
      d="m188.1 2.3-26.7 26.8v-.9l25.9-25.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be956c",
      }}
      d="m189 2.3-27.6 27.6v-.8l26.7-26.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bf966c",
      }}
      d="m189.8 2.3-28.4 28.4v-.8L189 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c0966c",
      }}
      d="m190.6 2.3-29.2 29.2v-.8l28.4-28.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c0976c",
      }}
      d="m191.4 2.3-30 30v-.8l29.2-29.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c1976c",
      }}
      d="m192.2 2.3-30.8 30.9v-.9l30-30z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c2986c",
      }}
      d="M193.1 2.3 161.4 34v-.8l30.8-30.9zm.8 0-32.5 32.5V34l31.7-31.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c2986c",
      }}
      d="m194.7 2.3-33.3 33.3v-.8l32.5-32.5zm1.3 0-34.6 34.6v-1.3l33.3-33.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c2996d",
      }}
      d="m197.3 2.3-35.9 35.9v-1.3L196 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c29a6e",
      }}
      d="m198.6 2.3-37.2 37.2v-1.3l35.9-35.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c1996f",
      }}
      d="m199.9 2.3-38.5 38.5v-1.3l37.2-37.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c09a6f",
      }}
      d="m201.2 2.3-39.8 39.8v-1.3l38.5-38.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c09a70",
      }}
      d="m202.5 2.3-41.1 41.1v-1.3l39.8-39.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c09b71",
      }}
      d="m203.8 2.3-42.4 42.4v-1.3l41.1-41.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bf9b72",
      }}
      d="m205 2.3-42.3 42.4h-1.3l42.4-42.4h1.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be9b73",
      }}
      d="m205 3.6-41 41.1h-1.3L205 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be9c73",
      }}
      d="m205 4.9-39.7 39.8H164l41-41.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be9c74",
      }}
      d="m205 6.2-38.4 38.5h-1.3L205 4.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be9c75",
      }}
      d="m205 7.5-37.2 37.2h-1.2L205 6.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be9d76",
      }}
      d="m205 8.8-35.9 35.9h-1.3L205 7.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bd9d77",
      }}
      d="m205 10.1-34.6 34.6h-1.3L205 8.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bd9e78",
      }}
      d="m205 11.4-33.3 33.3h-1.3L205 10.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bc9e78",
      }}
      d="m205 12.7-32 32h-1.3L205 11.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bc9e79",
      }}
      d="m205 14-30.7 30.7H173l32-32z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bc9f7a",
      }}
      d="m205 15.3-29.4 29.4h-1.3L205 14z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bb9f7b",
      }}
      d="m205 16.6-28.1 28.1h-1.3L205 15.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#baa07c",
      }}
      d="m205 17.9-26.8 26.8h-1.3L205 16.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#baa07c",
      }}
      d="m205 19.2-25.5 25.5h-1.3L205 17.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#baa07d",
      }}
      d="m205 20.4-24.2 24.3h-1.3L205 19.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b9a17e",
      }}
      d="m205 21.7-22.9 23h-1.3L205 20.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b8a17f",
      }}
      d="m205 23-21.6 21.7h-1.3l22.9-23z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b8a180",
      }}
      d="m205 24.3-20.3 20.4h-1.3L205 23z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b8a280",
      }}
      d="m205 25.6-19 19.1h-1.3L205 24.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b7a280",
      }}
      d="m205 26.9-17.7 17.8H186l19-19.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b6a381",
      }}
      d="m205 28.2-16.5 16.5h-1.2L205 26.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b7a382",
      }}
      d="m205 29.5-15.2 15.2h-1.3L205 28.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b6a483",
      }}
      d="m205 30.8-13.9 13.9h-1.3L205 29.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b5a484",
      }}
      d="m205 32.1-12.6 12.6h-1.3L205 30.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b4a485",
      }}
      d="m205 33.4-11.3 11.3h-1.3L205 32.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b5a586",
      }}
      d="m205 34.7-10 10h-1.3L205 33.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b4a586",
      }}
      d="m205 36-8.7 8.7H195l10-10z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b3a587",
      }}
      d="m205 37.3-7.4 7.4h-1.3L205 36z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2a688",
      }}
      d="m205 38.6-6.1 6.1h-1.3l7.4-7.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b3a689",
      }}
      d="m205 39.9-4.8 4.8h-1.3l6.1-6.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2a68a",
      }}
      d="m205 41.1-3.5 3.6h-1.3l4.8-4.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b1a68b",
      }}
      d="m205 42.4-2.2 2.3h-1.3l3.5-3.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2a78c",
      }}
      d="m205 43.7-.9 1h-1.3l2.2-2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b1a88d",
      }}
      d="m204.1 44.7.9-1v1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94807d",
      }}
      d="m63.8 7.7-.4.4v-.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94807c",
      }}
      d="M64.7 7.7 63.4 9v-.9l.4-.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#937f7b",
      }}
      d="m65.6 7.7-2.2 2.2V9l1.3-1.3zm.9 0-3.1 3.1v-.9l2.2-2.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#927e7a",
      }}
      d="m67.4 7.7-4 3.9v-.8l3.1-3.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#927d79",
      }}
      d="m68.3 7.7-4.9 4.8v-.9l4-3.9zm.9 0-5.8 5.7v-.9l4.9-4.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917c78",
      }}
      d="m70.1 7.7-6.7 6.6v-.9l5.8-5.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917b78",
      }}
      d="m71 7.7-7.6 7.5v-.9l6.7-6.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917a77",
      }}
      d="m71.8 7.7-8.4 8.4v-.9L71 7.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917a76",
      }}
      d="M72.7 7.7 63.4 17v-.9l8.4-8.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#907976",
      }}
      d="M73.6 7.7 63.4 17.9V17l9.3-9.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#907875",
      }}
      d="m74.5 7.7-11.1 11v-.8L73.6 7.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#907874",
      }}
      d="m75.4 7.7-12 11.9v-.9l11.1-11z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8f7774",
      }}
      d="M76.3 7.7 63.4 20.5v-.9l12-11.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8f7673",
      }}
      d="M77.2 7.7 63.4 21.4v-.9L76.3 7.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e7672",
      }}
      d="M78.1 7.7 63.4 22.3v-.9L77.2 7.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e7572",
      }}
      d="M79 7.7 63.4 23.2v-.9L78.1 7.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e7471",
      }}
      d="m79.1 7.7.4.4-16.1 16v-.9L79 7.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d7471",
      }}
      d="m79.5 8.1.4.4L63.4 25v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d7370",
      }}
      d="m79.9 8.5.5.4-17 17V25z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d726f",
      }}
      d="m80.4 8.9.4.5-17.4 17.3v-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8c716f",
      }}
      d="m80.8 9.4.5.4-17.9 17.8v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8c716e",
      }}
      d="m81.3 9.8.4.5-18.3 18.2v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8c706d",
      }}
      d="m81.7 10.3.4.4L64 28.9h-.6v-.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6f6d",
      }}
      d="m82.1 10.7.5.5-17.7 17.7H64z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6f6c",
      }}
      d="m82.6 11.2.4.4-17.2 17.3h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6e6b",
      }}
      d="m83 11.6.5.5-16.9 16.8h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8a6e6b",
      }}
      d="m83.5 12.1.4.4-16.4 16.4h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8a6d6a",
      }}
      d="m83.9 12.5.5.4-16 16h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896c6a",
      }}
      d="m84.4 12.9.4.5-15.5 15.5h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896b69",
      }}
      d="m84.8 13.4.5.4-15.1 15.1h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886b68",
      }}
      d="m85.3 13.8.4.5-14.6 14.6h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886a68",
      }}
      d="m85.7 14.3.4.4L72 28.9h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886a68",
      }}
      d="m86.1 14.7.5.5-13.7 13.7H72z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886967",
      }}
      d="m86.6 15.2.4.4-13.2 13.3h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876866",
      }}
      d="m87 15.6.5.5-12.9 12.8h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876866",
      }}
      d="m87.5 16.1.4.4-12.4 12.4h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876765",
      }}
      d="m87.9 16.5.5.4-12 12h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866764",
      }}
      d="m88.4 16.9.4.5-11.5 11.5h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866664",
      }}
      d="m88.8 17.4.4.4-11 11.1h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856563",
      }}
      d="m89.2 17.8.3.3v.3L79.1 28.9h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856563",
      }}
      d="M89.5 19.3 80 28.9h-.9l10.4-10.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856462",
      }}
      d="m89.5 20.2-8.6 8.7H80l9.5-9.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846462",
      }}
      d="m89.5 21.1-7.7 7.8h-.9l8.6-8.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846361",
      }}
      d="m89.5 22-6.9 6.9h-.8l7.7-7.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846261",
      }}
      d="m89.5 22.9-6 6h-.9l6.9-6.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846261",
      }}
      d="m89.5 23.8-5.1 5.1h-.9l6-6zm0 .8-4.3 4.3h-.8l5.1-5.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856361",
      }}
      d="m89.5 25.4-3.4 3.5h-.9l4.3-4.3zm0 .8-2.6 2.7h-.8l3.4-3.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866461",
      }}
      d="m89.5 27.1-1.8 1.8h-.8l2.6-2.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866561",
      }}
      d="m89.5 27.9-1 1h-.8l1.8-1.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876562",
      }}
      d="m89.5 28.7-.2.2h-.8l1-1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886662",
      }}
      d="m89.3 28.9.2-.2v.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#988d88",
      }}
      d="m52.3 2.3-.8.8v-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#988c88",
      }}
      d="M53.2 2.3 51.5 4v-.9l.8-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#988b87",
      }}
      d="m54.1 2.3-2.6 2.6V4l1.7-1.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978b86",
      }}
      d="m55 2.3-3.5 3.5v-.9l2.6-2.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978a86",
      }}
      d="m55.9 2.3-4.4 4.4v-.9L55 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978a85",
      }}
      d="m56.8 2.3-5.3 5.3v-.9l4.4-4.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978984",
      }}
      d="m57.7 2.3-6.2 6.2v-.9l5.3-5.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978884",
      }}
      d="m58.6 2.3-7.1 7.1v-.9l6.2-6.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968783",
      }}
      d="m59.4 2.3-7.9 7.9v-.8l7.1-7.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968782",
      }}
      d="m60.3 2.3-8.8 8.8v-.9l7.9-7.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968682",
      }}
      d="M61.2 2.3 51.5 12v-.9l8.8-8.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968581",
      }}
      d="M62.1 2.3 51.5 12.9V12l9.7-9.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968580",
      }}
      d="M63 2.3 51.5 13.8v-.9L62.1 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#958480",
      }}
      d="M63.9 2.3 51.5 14.7v-.9L63 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#958380",
      }}
      d="M64.8 2.3 51.5 15.6v-.9L63.9 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#95827f",
      }}
      d="M65.7 2.3 51.5 16.5v-.9L64.8 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94827f",
      }}
      d="m66.5 2.3-15 15.1v-.9L65.7 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94817e",
      }}
      d="M67.4 2.3 51.5 18.2v-.8l15-15.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94807d",
      }}
      d="M68.3 2.3 51.5 19.1v-.9L67.4 2.3zm.9 0L51.5 20v-.9L68.3 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94807c",
      }}
      d="M70.1 2.3 51.5 20.9V20L69.2 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#937f7b",
      }}
      d="M71 2.3 51.5 21.8v-.9L70.1 2.3zm.9 0L51.5 22.7v-.9L71 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#927e7a",
      }}
      d="M72.8 2.3 51.5 23.6v-.9L71.9 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#927d79",
      }}
      d="M73.7 2.3 51.5 24.5v-.9L72.8 2.3zm.8 0-23 23.1v-.9L73.7 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917c78",
      }}
      d="M75.4 2.3 51.5 26.2v-.8l23-23.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917b78",
      }}
      d="M76.3 2.3 51.5 27.1v-.9L75.4 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917a77",
      }}
      d="M77.2 2.3 51.5 28v-.9L76.3 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917a76",
      }}
      d="M78.1 2.3 51.5 28.9V28L77.2 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#907976",
      }}
      d="M79 2.3 51.5 29.8v-.9L78.1 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#907875",
      }}
      d="M79.9 2.3 51.5 30.7v-.9L79 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#907874",
      }}
      d="M80.8 2.3 51.5 31.6v-.9L79.9 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8f7774",
      }}
      d="M81.7 2.3 51.5 32.5v-.9L80.8 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8f7673",
      }}
      d="m81.7 2.3.4.4-30.6 30.7v-.9L81.7 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e7672",
      }}
      d="m82.1 2.7.5.5-31.1 31v-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e7572",
      }}
      d="m82.6 3.2.4.4-31.5 31.5v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e7471",
      }}
      d="m83 3.6.5.5-32 31.9v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d7471",
      }}
      d="m83.5 4.1.4.4-32.4 32.4V36z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d7370",
      }}
      d="m83.9 4.5.5.4-32.9 32.9v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d726f",
      }}
      d="m84.4 4.9.4.5-33.3 33.3v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8c716f",
      }}
      d="m84.8 5.4.5.4-33.8 33.8v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8c716e",
      }}
      d="m85.3 5.8.4.5-34.2 34.2v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8c706d",
      }}
      d="m85.7 6.3.4.4-34.6 34.7v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6f6d",
      }}
      d="m86.1 6.7.5.5-35.1 35v-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6f6c",
      }}
      d="m86.6 7.2.4.4-35.5 35.5v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6e6b",
      }}
      d="m87 7.6.5.5-36 35.9v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8a6e6b",
      }}
      d="m87.5 8.1.4.4-36.2 36.2h-.2V44z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8a6d6a",
      }}
      d="m87.9 8.5.5.4-35.8 35.8h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896c6a",
      }}
      d="m88.4 8.9.4.5-35.3 35.3h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896b69",
      }}
      d="m88.8 9.4.5.4-34.9 34.9h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886b68",
      }}
      d="m89.3 9.8.4.5-34.4 34.4h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886a68",
      }}
      d="m89.7 10.3.4.4-33.9 34h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886a68",
      }}
      d="m90.1 10.7.5.5L57 44.7h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886967",
      }}
      d="m90.6 11.2.4.4-33.1 33.1H57z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876866",
      }}
      d="m91 11.6.5.5-32.7 32.6h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876866",
      }}
      d="m91.5 12.1.4.4-32.2 32.2h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876765",
      }}
      d="m91.9 12.5.5.4-31.8 31.8h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866764",
      }}
      d="m92.4 12.9.4.5-31.3 31.3h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866664",
      }}
      d="m92.8 13.4.4.4-30.8 30.9h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856563",
      }}
      d="m93.2 13.8.5.5-30.4 30.4h-.9zm.5.5.4.4-29.9 30h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856462",
      }}
      d="m94.1 14.7.5.5L65 44.7h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846462",
      }}
      d="m94.6 15.2.4.4-29.1 29.1H65z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846361",
      }}
      d="m95 15.6.5.5-28.7 28.6h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846261",
      }}
      d="m95.5 16.1.4.4-28.2 28.2h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846261",
      }}
      d="m95.9 16.5.5.4-27.8 27.8h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846261",
      }}
      d="m96.4 16.9.4.5-27.4 27.3h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856361",
      }}
      d="m96.8 17.4.4.4-27 26.9h-.8zm.4.4.4.4-26.5 26.5h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866461",
      }}
      d="m97.6 18.2.4.4-26.1 26.1h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866561",
      }}
      d="m98 18.6.4.4-25.7 25.7h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876562",
      }}
      d="m98.4 19 .4.4-25.3 25.3h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886662",
      }}
      d="m98.8 19.4.4.4-24.9 24.9h-.8zm.4.4.4.4-24.4 24.5h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896762",
      }}
      d="m99.6 20.2.5.4L76 44.7h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896762",
      }}
      d="m100.1 20.6.4.4-23.7 23.7H76z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6863",
      }}
      d="m100.5 21 .4.5-23.3 23.2h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6964",
      }}
      d="m100.9 21.5.4.4-22.8 22.8h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8c6964",
      }}
      d="m101.3 21.9.4.4-22.4 22.4h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d6a64",
      }}
      d="m101.7 22.3.4.4-22 22h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d6b64",
      }}
      d="m102.1 22.7.4.4-21.6 21.6h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e6b64",
      }}
      d="m102.5 23.1.4.4-21.2 21.2h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e6c65",
      }}
      d="m102.9 23.5.4.4-20.7 20.8h-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8f6c65",
      }}
      d="m103.3 23.9.4.4-20.3 20.4h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#906d65",
      }}
      d="m103.7 24.3.5.4-20 20h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#906d65",
      }}
      d="m104.2 24.7.3.4v.1L85 44.7h-.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#916e65",
      }}
      d="M104.5 26 85.8 44.7H85l19.5-19.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#916e65",
      }}
      d="M104.5 26.8 86.7 44.7h-.9L104.5 26z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#936f66",
      }}
      d="m104.5 27.7-17 17h-.8l17.8-17.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#937066",
      }}
      d="M104.5 28.5 88.3 44.7h-.8l17-17z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#947166",
      }}
      d="M104.5 29.3 89.1 44.7h-.8l16.2-16.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#957166",
      }}
      d="M104.5 30.1 89.9 44.7h-.8l15.4-15.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#957267",
      }}
      d="M104.5 30.9 90.8 44.7h-.9l14.6-14.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#967267",
      }}
      d="M104.5 31.8 91.6 44.7h-.8l13.7-13.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#967367",
      }}
      d="M104.5 32.6 92.4 44.7h-.8l12.9-12.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#977367",
      }}
      d="M104.5 33.4 93.2 44.7h-.8l12.1-12.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#987467",
      }}
      d="M104.5 34.2 94 44.7h-.8l11.3-11.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#987467",
      }}
      d="m104.5 35.1-9.6 9.6H94l10.5-10.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#997568",
      }}
      d="m104.5 35.9-8.8 8.8h-.8l9.6-9.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#997668",
      }}
      d="m104.5 36.7-8 8h-.8l8.8-8.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a7668",
      }}
      d="m104.5 37.5-7.2 7.2h-.8l8-8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b7768",
      }}
      d="m104.5 38.3-6.3 6.4h-.9l7.2-7.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9c7869",
      }}
      d="M104.5 39.2 99 44.7h-.8l6.3-6.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9d7869",
      }}
      d="m104.5 40-4.7 4.7H99l5.5-5.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9e7969",
      }}
      d="m104.5 40.8-3.9 3.9h-.8l4.7-4.7zm0 .8-3.1 3.1h-.8l3.9-3.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9e7a69",
      }}
      d="m104.5 42.4-2.2 2.3h-.9l3.1-3.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9f7b69",
      }}
      d="m104.5 43.3-1.4 1.4h-.8l2.2-2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a07b69",
      }}
      d="m104.5 44.1-.6.6h-.8l1.4-1.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a17c69",
      }}
      d="m103.9 44.7.6-.6v.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9cb6b0",
      }}
      d="m3.5 2.3-.9.9v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9cb5af",
      }}
      d="M4.3 2.3 2.6 4.1v-.9l.9-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9bb3ad",
      }}
      d="M5.2 2.3 2.6 5v-.9l1.7-1.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9cb3ac",
      }}
      d="M6.1 2.3 2.6 5.9V5l2.6-2.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9cb1ab",
      }}
      d="M7 2.3 2.6 6.8v-.9l3.5-3.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9bb1ab",
      }}
      d="M7.9 2.3 2.6 7.6v-.8L7 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9cb0aa",
      }}
      d="M8.8 2.3 2.6 8.5v-.9l5.3-5.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9cb0a9",
      }}
      d="M9.7 2.3 2.6 9.4v-.9l6.2-6.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9caea8",
      }}
      d="m10.6 2.3-8 8v-.9l7.1-7.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9caea8",
      }}
      d="m11.5 2.3-8.9 8.9v-.9l8-8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9cada7",
      }}
      d="m12.3 2.3-9.7 9.8v-.9l8.9-8.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9baca6",
      }}
      d="M13.2 2.3 2.6 13v-.9l9.7-9.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9caba5",
      }}
      d="M14.1 2.3 2.6 13.9V13L13.2 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9baba5",
      }}
      d="M15 2.3 2.6 14.8v-.9L14.1 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9caaa4",
      }}
      d="M15.9 2.3 2.6 15.6v-.8L15 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9caaa3",
      }}
      d="M16.8 2.3 2.6 16.5v-.9L15.9 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca8a3",
      }}
      d="M17.7 2.3 2.6 17.4v-.9L16.8 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca8a2",
      }}
      d="m18.6 2.3-16 16v-.9L17.7 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca7a1",
      }}
      d="M19.4 2.3 2.6 19.2v-.9l16-16zm.9 0L2.6 20.1v-.9L19.4 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca6a0",
      }}
      d="M21.2 2.3 2.6 21v-.9L20.3 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca5a0",
      }}
      d="M22.1 2.3 2.6 21.9V21L21.2 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca49e",
      }}
      d="M23 2.3 2.6 22.8v-.9L22.1 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca49e",
      }}
      d="M23.9 2.3 2.6 23.6v-.8L23 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ba39d",
      }}
      d="M24.8 2.3 2.6 24.5v-.9L23.9 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca29c",
      }}
      d="M25.7 2.3 2.6 25.4v-.9L24.8 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca19c",
      }}
      d="m26.6 2.3-24 24v-.9L25.7 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca19b",
      }}
      d="M27.4 2.3 2.6 27.2v-.9l24-24z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca09a",
      }}
      d="M28.3 2.3 2.6 28.1v-.9L27.4 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9ca09a",
      }}
      d="M29.2 2.3 2.6 29v-.9L28.3 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9c9f99",
      }}
      d="M30.1 2.3 2.6 29.9V29L29.2 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9c9e99",
      }}
      d="M31 2.3 2.6 30.8v-.9L30.1 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b9d98",
      }}
      d="M31.9 2.3 2.6 31.6v-.8L31 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9c9d97",
      }}
      d="M32.8 2.3 2.6 32.5v-.9L31.9 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9c9c97",
      }}
      d="M33.7 2.3 2.6 33.4v-.9L32.8 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b9b95",
      }}
      d="m34.6 2.3-32 32v-.9L33.7 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b9a95",
      }}
      d="M35.4 2.3 2.6 35.2v-.9l32-32z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b9a94",
      }}
      d="M36.3 2.3 2.6 36.1v-.9L35.4 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b9994",
      }}
      d="M37.2 2.3 2.6 37v-.9L36.3 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b9893",
      }}
      d="M38.1 2.3 2.6 37.9V37L37.2 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a9892",
      }}
      d="M39 2.3 2.6 38.8v-.9L38.1 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b9792",
      }}
      d="M39.9 2.3 2.6 39.6v-.8L39 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b9791",
      }}
      d="M40.8 2.3 2.6 40.5v-.9L39.9 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a9690",
      }}
      d="M41.7 2.3 2.6 41.4v-.9L40.8 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a9590",
      }}
      d="m42.6 2.3-40 40v-.9L41.7 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a948f",
      }}
      d="M43.4 2.3 2.6 43.2v-.9l40-40z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a948f",
      }}
      d="M44.3 2.3 2.6 44.1v-.9L43.4 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a938e",
      }}
      d="M45.2 2.3 2.8 44.7h-.2v-.6L44.3 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a928d",
      }}
      d="M46.1 2.3 3.7 44.7h-.9L45.2 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a918c",
      }}
      d="M46.1 3.2 4.6 44.7h-.9L46.1 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a918c",
      }}
      d="M46.1 4.1 5.5 44.7h-.9L46.1 3.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#99908b",
      }}
      d="M46.1 5 6.4 44.7h-.9L46.1 4.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#998f8a",
      }}
      d="M46.1 5.8 7.3 44.7h-.9L46.1 5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#988e89",
      }}
      d="m46.1 6.7-37.9 38h-.9L46.1 5.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#988e89",
      }}
      d="m46.1 7.6-37 37.1h-.9l37.9-38z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#988d88",
      }}
      d="M46.1 8.5 9.9 44.7h-.8l37-37.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#988c88",
      }}
      d="M46.1 9.4 10.8 44.7h-.9L46.1 8.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#988b87",
      }}
      d="M46.1 10.3 11.7 44.7h-.9L46.1 9.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978b86",
      }}
      d="M46.1 11.2 12.6 44.7h-.9l34.4-34.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978a86",
      }}
      d="M46.1 12.1 13.5 44.7h-.9l33.5-33.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978a85",
      }}
      d="M46.1 13 14.4 44.7h-.9l32.6-32.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978984",
      }}
      d="M46.1 13.8 15.3 44.7h-.9L46.1 13z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#978884",
      }}
      d="m46.1 14.7-29.9 30h-.9l30.8-30.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968783",
      }}
      d="m46.1 15.6-29 29.1h-.9l29.9-30z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968782",
      }}
      d="M46.1 16.5 17.9 44.7h-.8l29-29.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968682",
      }}
      d="M46.1 17.4 18.8 44.7h-.9l28.2-28.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968581",
      }}
      d="M46.1 18.3 19.7 44.7h-.9l27.3-27.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#968580",
      }}
      d="M46.1 19.2 20.6 44.7h-.9l26.4-26.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#958480",
      }}
      d="M46.1 20.1 21.5 44.7h-.9l25.5-25.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#958380",
      }}
      d="M46.1 21 22.4 44.7h-.9l24.6-24.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#95827f",
      }}
      d="M46.1 21.8 23.3 44.7h-.9L46.1 21z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94827f",
      }}
      d="m46.1 22.7-21.9 22h-.9l22.8-22.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94817e",
      }}
      d="m46.1 23.6-21 21.1h-.9l21.9-22z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94807d",
      }}
      d="M46.1 24.5 25.9 44.7h-.8l21-21.1zm0 .9L26.8 44.7h-.9l20.2-20.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#94807c",
      }}
      d="M46.1 26.3 27.7 44.7h-.9l19.3-19.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#937f7b",
      }}
      d="M46.1 27.2 28.6 44.7h-.9l18.4-18.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#937f7b",
      }}
      d="M46.1 28.1 29.5 44.7h-.9l17.5-17.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#927e7a",
      }}
      d="M46.1 28.9 30.4 44.7h-.9l16.6-16.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#927d79",
      }}
      d="M46.1 29.8 31.3 44.7h-.9l15.7-15.8zm0 .9-13.9 14h-.9l14.8-14.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917c78",
      }}
      d="m46.1 31.6-13 13.1h-.9l13.9-14z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917b78",
      }}
      d="M46.1 32.5 33.9 44.7h-.8l13-13.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917a77",
      }}
      d="M46.1 33.4 34.8 44.7h-.9l12.2-12.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#917a76",
      }}
      d="M46.1 34.3 35.7 44.7h-.9l11.3-11.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#907976",
      }}
      d="m46.1 35.2-9.5 9.5h-.9l10.4-10.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#907875",
      }}
      d="m46.1 36.1-8.6 8.6h-.9l9.5-9.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#907874",
      }}
      d="m46.1 36.9-7.7 7.8h-.9l8.6-8.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8f7774",
      }}
      d="m46.1 37.8-6.8 6.9h-.9l7.7-7.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8f7673",
      }}
      d="m46.1 38.7-5.9 6h-.9l6.8-6.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e7672",
      }}
      d="m46.1 39.6-5 5.1h-.9l5.9-6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e7572",
      }}
      d="m46.1 40.5-4.2 4.2h-.8l5-5.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e7471",
      }}
      d="m46.1 41.4-3.3 3.3h-.9l4.2-4.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d7471",
      }}
      d="m46.1 42.3-2.4 2.4h-.9l3.3-3.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d7370",
      }}
      d="m46.1 43.2-1.5 1.5h-.9l2.4-2.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d726f",
      }}
      d="m46.1 44.1-.6.6h-.9l1.5-1.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8c716f",
      }}
      d="m45.5 44.7.6-.6v.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a17c69",
      }}
      d="m147.9 2.3-.6.7v-.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a27d69",
      }}
      d="m148.7 2.3-1.4 1.5V3l.6-.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a27d6a",
      }}
      d="m149.6 2.3-2.3 2.3v-.8l1.4-1.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a37e6a",
      }}
      d="m150.4 2.3-3.1 3.1v-.8l2.3-2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a37e6a",
      }}
      d="m151.2 2.3-3.9 4v-.9l3.1-3.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a47f6a",
      }}
      d="m151.8 2.5-4.5 4.6v-.8l3.9-4h.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a57f6a",
      }}
      d="m151.8 3.3-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a6806b",
      }}
      d="m151.8 4.1-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a6806a",
      }}
      d="m151.8 5-4.5 4.6v-.9l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a6806a",
      }}
      d="m151.8 5.8-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a7816a",
      }}
      d="m151.8 6.6-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a8816b",
      }}
      d="m151.8 7.4-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a9826b",
      }}
      d="m151.8 8.2-4.5 4.6V12l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a9826b",
      }}
      d="m151.8 9.1-4.5 4.6v-.9l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#aa836b",
      }}
      d="m151.8 9.9-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#aa836b",
      }}
      d="m151.8 10.7-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ab846b",
      }}
      d="m151.8 11.5-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ac856c",
      }}
      d="m151.8 12.3-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ad866c",
      }}
      d="m151.8 13.2-4.5 4.6v-.9l4.5-4.6zm0 .8-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ae876c",
      }}
      d="m151.8 14.8-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ae876c",
      }}
      d="m151.8 15.6-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#af886c",
      }}
      d="m151.8 16.4-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b0886c",
      }}
      d="m151.8 17.3-4.5 4.6V21l4.5-4.6zm0 .8-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b1896c",
      }}
      d="m151.8 18.9-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2896c",
      }}
      d="m151.8 19.7-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b28b6c",
      }}
      d="m151.8 20.6-4.5 4.5v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b28b6c",
      }}
      d="m151.8 21.4-4.5 4.6v-.9l4.5-4.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b38b6c",
      }}
      d="m151.8 22.2-4.5 4.6V26l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b48c6c",
      }}
      d="m151.8 23-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b58c6d",
      }}
      d="m151.8 23.8-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b58c6c",
      }}
      d="m151.8 24.7-4.5 4.6v-.9l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b58d6c",
      }}
      d="m151.8 25.5-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b68d6c",
      }}
      d="m151.8 26.3-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b68e6c",
      }}
      d="m151.8 27.1-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b78e6c",
      }}
      d="m151.8 27.9-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b78f6c",
      }}
      d="m151.8 28.8-4.5 4.6v-.9l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b8906c",
      }}
      d="m151.8 29.6-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b9906c",
      }}
      d="m151.8 30.4-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b9916c",
      }}
      d="m151.8 31.2-4.5 4.6V35l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ba916c",
      }}
      d="m151.8 32-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ba916d",
      }}
      d="m151.8 32.9-4.5 4.6v-.9l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bb926c",
      }}
      d="m151.8 33.7-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bb926c",
      }}
      d="m151.8 34.5-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bc936d",
      }}
      d="m151.8 35.3-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bd936c",
      }}
      d="m151.8 36.1-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be946c",
      }}
      d="m151.8 37-4.5 4.6v-.9l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be956c",
      }}
      d="m151.8 37.8-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bd956c",
      }}
      d="m151.8 38.6-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#be956c",
      }}
      d="m151.8 39.4-4.5 4.6v-.8l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#bf966c",
      }}
      d="m151.8 40.3-4.4 4.4h-.1V44l4.5-4.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c0966c",
      }}
      d="m151.8 41.1-3.6 3.6h-.8l4.4-4.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c0976c",
      }}
      d="m151.8 41.9-2.8 2.8h-.8l3.6-3.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c1976c",
      }}
      d="m151.8 42.7-1.9 2h-.9l2.8-2.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c2986c",
      }}
      d="m151.8 43.5-1.1 1.2h-.8l1.9-2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#c2986c",
      }}
      d="m151.8 44.4-.3.3h-.8l1.1-1.2zm-.3.3.3-.3v.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6e6b",
      }}
      d="M93.2 2.3v.1-.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8a6e6b",
      }}
      d="m94.1 2.3-.9.9v-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8a6d6a",
      }}
      d="m95 2.3-1.8 1.8v-.9l.9-.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896c6a",
      }}
      d="M95.9 2.3 93.2 5v-.9L95 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896b69",
      }}
      d="m96.8 2.3-3.6 3.6V5l2.7-2.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886b68",
      }}
      d="m97.7 2.3-4.5 4.5v-.9l3.6-3.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886a68",
      }}
      d="m98.5 2.3-5.3 5.4v-.9l4.5-4.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886a68",
      }}
      d="m99.4 2.3-6.2 6.3v-.9l5.3-5.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886967",
      }}
      d="m100.3 2.3-7.1 7.2v-.9l6.2-6.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876866",
      }}
      d="m101.2 2.3-8 8.1v-.9l7.1-7.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876866",
      }}
      d="m102.1 2.3-8.9 8.9v-.8l8-8.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876765",
      }}
      d="m103 2.3-9.8 9.8v-.9l8.9-8.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866764",
      }}
      d="M103.9 2.3 93.2 13v-.9l9.8-9.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866664",
      }}
      d="M104.8 2.3 93.2 13.9V13l10.7-10.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856563",
      }}
      d="M105.7 2.3 93.2 14.8v-.9l11.6-11.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856563",
      }}
      d="M106.5 2.3 93.2 15.7v-.9l12.5-12.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856462",
      }}
      d="M107.4 2.3 93.2 16.6v-.9l13.3-13.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846462",
      }}
      d="M108.3 2.3 93.2 17.5v-.9l14.2-14.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846361",
      }}
      d="m109.2 2.3-16 16.1v-.9l15.1-15.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846261",
      }}
      d="M110.1 2.3 93.2 19.2v-.8l16-16.1zm.9 0L93.2 20.1v-.9l16.9-16.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#846261",
      }}
      d="M111.8 2.3 93.2 20.9v-.8L111 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856361",
      }}
      d="M112.6 2.3 93.2 21.8v-.9l18.6-18.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#856361",
      }}
      d="M113.4 2.3 93.2 22.6v-.8l19.4-19.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866461",
      }}
      d="M114.3 2.3 93.2 23.4v-.8l20.2-20.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#866561",
      }}
      d="M115.1 2.3 93.2 24.2v-.8l21.1-21.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#876562",
      }}
      d="M115.9 2.3 93.2 25.1v-.9l21.9-21.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886662",
      }}
      d="M116.7 2.3 93.3 25.7l-.1-.1v-.5l22.7-22.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#886662",
      }}
      d="M117.5 2.3 93.7 26.1l-.4-.4 23.4-23.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896762",
      }}
      d="M118.4 2.3 94.2 26.5l-.5-.4 23.8-23.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#896762",
      }}
      d="M119.2 2.3 94.6 26.9l-.4-.4 24.2-24.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6863",
      }}
      d="M120 2.3 95 27.4l-.4-.5 24.6-24.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8b6964",
      }}
      d="M120.8 2.3 95.4 27.8l-.4-.4 25-25.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8c6964",
      }}
      d="M121.7 2.3 95.8 28.2l-.4-.4 25.4-25.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d6a64",
      }}
      d="M122.5 2.3 96.2 28.6l-.4-.4 25.9-25.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8d6b64",
      }}
      d="M123.3 2.3 96.6 29l-.4-.4 26.3-26.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e6b64",
      }}
      d="M124.1 2.3 97 29.4l-.4-.4 26.7-26.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8e6c65",
      }}
      d="M124.9 2.3 97.4 29.8l-.4-.4 27.1-27.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#8f6c65",
      }}
      d="m125.8 2.3-28 27.9-.4-.4 27.5-27.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#906d65",
      }}
      d="M126.6 2.3 98.3 30.6l-.5-.4 28-27.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#906d65",
      }}
      d="M127.4 2.3 98.7 31.1l-.4-.5 28.3-28.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#916e65",
      }}
      d="M128.2 2.3 99.1 31.5l-.4-.4 28.7-28.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#916e65",
      }}
      d="M129 2.3 99.5 31.9l-.4-.4 29.1-29.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#936f66",
      }}
      d="m129.9 2.3-30 30-.4-.4L129 2.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#937066",
      }}
      d="m130.7 2.3-30.4 30.4-.4-.4 30-30z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#947166",
      }}
      d="m131.5 2.3-30.8 30.8-.4-.4 30.4-30.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#957166",
      }}
      d="m132.3 2.3-31.2 31.2-.4-.4 30.8-30.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#957267",
      }}
      d="m133.1 2.3-31.6 31.6-.4-.4 31.2-31.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#967267",
      }}
      d="m134 2.3-32.1 32-.4-.4 31.6-31.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#967367",
      }}
      d="m134.8 2.3-32.4 32.4-.5-.4 32.1-32z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#977367",
      }}
      d="m135.6 2.3-32.8 32.9-.4-.5 32.4-32.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#987467",
      }}
      d="m136.4 2.3-33.2 33.3-.4-.4 32.8-32.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#987467",
      }}
      d="M137.2 2.3 103.6 36l-.4-.4 33.2-33.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#997568",
      }}
      d="M138.1 2.3 104 36.4l-.4-.4 33.6-33.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#997668",
      }}
      d="m138.9 2.3-34.5 34.5-.4-.4 34.1-34.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9a7668",
      }}
      d="m139.5 2.5-34.7 34.7-.4-.4 34.5-34.5h.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9b7768",
      }}
      d="m139.5 3.4-34.3 34.2-.4-.4 34.7-34.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9c7869",
      }}
      d="M139.5 4.2 105.6 38l-.4-.4 34.3-34.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9d7869",
      }}
      d="m139.5 5-33.4 33.4-.5-.4 33.9-33.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9e7969",
      }}
      d="m139.5 5.8-33 33-.4-.4L139.5 5zm0 .8-32.6 32.7-.4-.5 33-33z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9e7a69",
      }}
      d="m139.5 7.5-32.2 32.2-.4-.4 32.6-32.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#9f7b69",
      }}
      d="m139.5 8.3-31.8 31.8-.4-.4 32.2-32.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a07b69",
      }}
      d="m139.5 9.1-31.4 31.4-.4-.4 31.8-31.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a17c69",
      }}
      d="m139.5 9.9-31 31-.4-.4 31.4-31.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a17c69",
      }}
      d="m139.5 10.7-30.6 30.6-.4-.4 31-31z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a27d69",
      }}
      d="m139.5 11.6-30.2 30.1-.4-.4 30.6-30.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a27d6a",
      }}
      d="m139.5 12.4-29.8 29.7-.4-.4 30.2-30.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a37e6a",
      }}
      d="m139.5 13.2-29.3 29.3-.5-.4 29.8-29.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a37e6a",
      }}
      d="m139.5 14-28.9 29-.4-.5 29.3-29.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a47f6a",
      }}
      d="M139.5 14.8 111 43.4l-.4-.4 28.9-29z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a57f6a",
      }}
      d="m139.5 15.7-28.1 28.1-.4-.4 28.5-28.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a6806b",
      }}
      d="m139.5 16.5-27.7 27.7-.4-.4 28.1-28.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a6806a",
      }}
      d="m139.5 17.3-27.3 27.3-.4-.4 27.7-27.7zm0 .8-26.6 26.6h-.6l-.1-.1 27.3-27.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a7816a",
      }}
      d="m139.5 19-25.8 25.7h-.8l26.6-26.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a8816b",
      }}
      d="m139.5 19.8-24.9 24.9h-.9L139.5 19z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a9826b",
      }}
      d="m139.5 20.6-24.1 24.1h-.8l24.9-24.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#a9826b",
      }}
      d="m139.5 21.4-23.3 23.3h-.8l24.1-24.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#aa836b",
      }}
      d="M139.5 22.2 117 44.7h-.8l23.3-23.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#aa836b",
      }}
      d="m139.5 23.1-21.6 21.6h-.9l22.5-22.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ab846b",
      }}
      d="m139.5 23.9-20.8 20.8h-.8l21.6-21.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ac856c",
      }}
      d="m139.5 24.7-20 20h-.8l20.8-20.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ad866c",
      }}
      d="m139.5 25.5-19.2 19.2h-.8l20-20zm0 .8-18.4 18.4h-.8l19.2-19.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ae876c",
      }}
      d="M139.5 27.2 122 44.7h-.9l18.4-18.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ae876c",
      }}
      d="m139.5 28-16.7 16.7h-.8l17.5-17.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#af886c",
      }}
      d="m139.5 28.8-15.9 15.9h-.8L139.5 28z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b0886c",
      }}
      d="m139.5 29.6-15.1 15.1h-.8l15.9-15.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b0886c",
      }}
      d="m139.5 30.4-14.3 14.3h-.8l15.1-15.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b1896c",
      }}
      d="m139.5 31.3-13.4 13.4h-.9l14.3-14.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b2896c",
      }}
      d="m139.5 32.1-12.6 12.6h-.8l13.4-13.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b28b6c",
      }}
      d="m139.5 32.9-11.8 11.8h-.8l12.6-12.6zm0 .8-11 11h-.8l11.8-11.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b38b6c",
      }}
      d="m139.5 34.5-10.2 10.2h-.8l11-11z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b48c6c",
      }}
      d="m139.5 35.4-9.3 9.3h-.9l10.2-10.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b58c6d",
      }}
      d="m139.5 36.2-8.5 8.5h-.8l9.3-9.3z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b58c6c",
      }}
      d="m139.5 37-7.7 7.7h-.8l8.5-8.5z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b58d6c",
      }}
      d="m139.5 37.8-6.9 6.9h-.8l7.7-7.7z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b68d6c",
      }}
      d="m139.5 38.7-6.1 6h-.8l6.9-6.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b68e6c",
      }}
      d="m139.5 39.5-5.2 5.2h-.9l6.1-6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b78e6c",
      }}
      d="m139.5 40.3-4.4 4.4h-.8l5.2-5.2z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b78f6c",
      }}
      d="m139.5 41.1-3.6 3.6h-.8l4.4-4.4z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b8906c",
      }}
      d="m139.5 41.9-2.8 2.8h-.8l3.6-3.6z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b9906c",
      }}
      d="m139.5 42.8-1.9 1.9h-.9l2.8-2.8z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#b9916c",
      }}
      d="m139.5 43.6-1.1 1.1h-.8l1.9-1.9z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ba916c",
      }}
      d="m139.5 44.4-.3.3h-.8l1.1-1.1z"
    />
    <path
      style={{
        clipPath: "url(#b)",
        fill: "#ba916d",
      }}
      d="m139.2 44.7.3-.3v.3z"
    />
  </svg>
);

const Input = styled.input``;

const Textarea = styled.textarea`
  position: fixed;
  right: -9990px;
  top: -9990px;
`;

// transition:ease-in-out 0.5s margin-top;
// 	transition-delay:0.05s;

const SuperHeader = styled.div`
  height: 150px;
  background: #374650;
  margin-top: ${(props) => (props.active ? "0px" : "-150px")};
  display: ${(props) => (props.hidden ? "hidden" : "flex")};
  background-image: url(${require("./pattern-dots.svg").default});
  background-size: auto 50%;
  background-position: 20px 20px;
  background-repeat: no-repeat;
  position: relative;
`;
export default withRouter(SidebarCompontent);
